import { ListResponse } from "../../../model/common/ListResponse";
import { RepairShopReview } from "../../../model/RepairShopReivew";
import httpRequest from "../../../network/httpRequest";
import { ReviewQueryParams } from "./types";

export const fetchReviewDetail = async (
  repairShopId: number
): Promise<RepairShopReview> => {
  const url = `/repair-shop-reviews/${repairShopId}/detail`;
  const res = await httpRequest({ method: "get", url });
  return res?.data.row;
};

export const fetchReviewList = async (
  queryParams: ReviewQueryParams
): Promise<ListResponse<RepairShopReview>> => {
  const url = `/repair-shop-reviews`;
  const res = await httpRequest({ method: "get", url, queryParams });

  return res?.data;
};
